<template>
<div>
    <!-- Status Tab -->
    <div class="mx-4 mt-4 mb-3">
        <div class="tab" @click="currentTab = 'profile'" :class="{active: currentTab == 'profile'}">
            {{$t('tab_profile')}}
        </div>
        <div v-if="canUseMemberPointsModule && customer?.sms_verified" class="tab" @click="currentTab = 'point_records'" :class="{active: currentTab == 'point_records'}">{{$t('tab_point_records')}}</div>
    </div>
    <!-- End Status Tab -->
    <customer-profile v-if="currentTab === 'profile'" :context="context" :provider="provider" />
    <customer-point-records v-else-if="currentTab === 'point_records'" :provider="provider" class="mt-4 mx-2"/>
</div>
</template>

<script>
import CustomerPointRecords from './crm/CustomerPointRecords.vue'
import CustomerProfile from './CustomerProfile.vue'
import CapabilityManager from '../bu/CapabilityManager';
import { mapGetters } from 'vuex';

export default {
    props: {
        context: {type: Object, required: true},
        provider: {type: Object, required: true}
    },
    components: { CustomerProfile, CustomerPointRecords },
    data() {
        const capabilityManager = new CapabilityManager(this.provider.grade, this.provider.capabilities);
        return {
            canUseMemberPointsModule: capabilityManager.canManageMemberPoints(),
            currentTab: 'profile'
        }
    },
    computed: {
        ...mapGetters({
            customer: 'app/customer'
        }),
    },
}
</script>

<style lang="scss" scoped>

.tab {
    font-size: 12px;
    display: inline-flex;
    background: transparent;
    padding: 8px 16px;
    color: #90A4AE;
    border: 1px solid transparent;
}

.tab.active, .tab:hover {
    border-radius: 24px;
    background: white;
    cursor: pointer;
    color: #F5C51E;
    border: 1px solid #F5C51E;
}

</style>

<i18n>
{
    "en": {
        "tab_profile": "Profile",
        "tab_point_records": "Member Point Records"
    },
    "zh": {
        "tab_profile": "個人資料",
        "tab_point_records": "會員點數紀錄"
    }
}
</i18n>